/****************************/
/* Profile helper functions */
/****************************/

var _ = require('underscore');
var $ = require('jquery');

var JSContext = require('./jscontext');
var resizing = require('./image-resizing');
var utils = require('./utils');


// Adds .naturalSize() methods to jQuery for retrieving natural width and height
// of an image.  Falls back to creating an Image object for older browers.
var addNaturalSizeTojQuery = function($) {
    $.fn['naturalSize'] = ('naturalWidth' in new Image()) ?
        // Modern browsers have the property, just return it
        function() {
            return {
                'width': this[0].naturalWidth,
                'height': this[0].naturalHeight
            };
        } :
        // Older versions of IE don't have it, so get it by using an
        // Image with no styling or layout applied
        function() {
            var node = this[0],
                value = {'width': 0, 'height': 0};

            if (node.tagName.toLowerCase() === 'img') {
                var tempImage = new Image();
                tempImage.src = node.src;
                value.width = tempImage.width;
                value.height = tempImage.height;
            }
            return value;
        };
};

var _getExtensionPosition = function(phone) {
    return phone.lastIndexOf("x");
};

var makeDesignationString = function(designationsArray, dictionary) {
    var output = [];
    _.each(designationsArray, function(designation) {
        if (designation && dictionary[designation]) {
            output.push(dictionary[designation].replace(/(®)/ig, "<sup>$1</sup>"));
        }
    });
    return output.join(", ");
};

/* Filter phone number to just the digits, and format nicely if asked. */
var phoneFormat = function(phone, pretty) {
    var prefix = "";
    if(!phone) {
        return;
    }
    if(phone.indexOf("+") !== -1) {
        prefix = "+";
    }
    var digits = utils.stripNonDigits(phone);
    if (!pretty) {
        return digits;
    } else {
        var extensionPosition = _getExtensionPosition(phone);
        var extension = "";
        if(extensionPosition !== -1) {
            var extDigits = utils.stripNonDigits(phone.slice(extensionPosition));
            if(extDigits) {
                digits = digits.replace(new RegExp(extDigits + "$"), "");
                extension = " ext. " + extDigits;
            }
        }
        if (digits.length === 11 && !prefix) {
            return digits.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4') + extension;
        }
        else if (digits.length === 10 && !prefix) {
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') + extension;
        }
        else if (extensionPosition !== -1) {
            var noExtPhone = phone.substring(0, phone.lastIndexOf('x'));
            return noExtPhone + extension;
        }
        else {
            return phone;
        }
    }
};

/* Filter zip code +4 to just the digits, and format nicely if asked. Note that this only works for US zip codes. */
var zipFormat = function(zipCode, pretty) {
    var digits = utils.stripNonDigits(zipCode);
    if(!pretty || digits.length !== 9) {
        return digits;
    } else {
        return digits.slice(0, 5) + "-" + digits.slice(5);
    }
};

/* Join a tag/list selection with commas (and "and" when appropriate) */
var tagJoin = function(list) {
    var last = list.length - 1;
    if (list.length < 2) {
        return list[0] || "";
    } else if (list.length === 2) {
        // No need for comma when only two items in list.
        return list[0] + " and " + list[1];
    } else {
        return list.slice(0, last).join(", ") + ", and " + list[last];
    }
};

/* Combine address elements into single string. */
var printAddress = function(address, fields) {
    address.city = address.city && address.city + ",";
    var fields = fields || ["street", "suite", "city", "state", "country", "zip_code"];
    var fullAddress = _.chain(fields)
        .map(_.propertyOf(address))
        .compact()
        .value()
        .join(" ");
    // Remove comma from profile address data for future use.
    address.city = address.city && _.initial(address.city).join("");
    return fullAddress;
};

/* Generate map from profile address object. */
var googleMapsLink = function(address) {
    return "http://maps.google.com/?q=" +
            encodeURIComponent(printAddress(address));
};

/* Generate directions from profile address object. */
var googleMapsDirections = function(address) {
    return "http://maps.google.com/?daddr=" +
            encodeURIComponent(printAddress(address));
};

var getTagDisplayValue = function(tagName, tagValue) {
    // Use source if available, otherwise fall back to tag canonical name.
    var source = JSContext.getCategoryMap()[tagName] || tagName;
    var categories = JSContext.getCategories();
    if (source && categories[source]) {
        return categories[source][tagValue];
    }
    return tagValue; // Default to tagValue
};

var getURLForSlug = function(slug) {
    return JSContext.getOrgLink() + slug;
};

var formatHref = function(protocol, value) {
    if(protocol && value) {
        return protocol + ":" + value;
    }
};

var scrollToHash = function() {
    var target = utils.parseUrl(window.location).hash;
    history.pushState('', document.title, window.location.pathname);

    if (target && !!document.querySelector(target)) {
        window.addEventListener('load', function() {
            var $nav = $('nav');

            $('html, body').animate({
                scrollTop: $(target).offset().top - ($nav.length ? $nav.height() : 0)
            }, 500);
        });
    }
};

exports.addNaturalSizeTojQuery = addNaturalSizeTojQuery;
exports.makeAbsolute = utils.makeAbsolute;
exports.makeDesignationString = makeDesignationString;
exports.phoneFormat = phoneFormat;
exports.zipFormat = zipFormat;
exports.tagJoin = tagJoin;
exports.printAddress = printAddress;
exports.googleMapsLink = googleMapsLink;
exports.googleMapsDirections = googleMapsDirections;
exports.getTagDisplayValue = getTagDisplayValue;
exports.getURLForSlug = getURLForSlug;
exports.formatHref = formatHref;
exports.resize = resizing.resize;
exports.scrollToHash = scrollToHash;



//////////////////
// WEBPACK FOOTER
// ../~/poly-js-utils/src/view-helpers.js
// module id = 165
// module chunks = 0